import React from "react";
import { Link, useNavigate } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import emailjs from "@emailjs/browser";
import { FolderOpen, MonitorMobbile, People } from "iconsax-react";

import Bg from "../../Assets/Image/earth-night.jpeg";
import Logo from "../../Assets/Logo/logowhite.svg";
import Building from "../../Assets/Image/building.png";
import Code from "../../Assets/Image/code.png";
import Consultant from "../../Assets/Image/Laptop-preview.png";
import SecurityCctv from "../../Assets/Image/CCTV-preview.png";
import Hardware from "../../Assets/Image/Hardware-preview.png";
import ITManagement from "../../Assets/Image/IT-preview.png";
import BgVideo from "../../Assets/Videos/bg_banner.mp4";
import Impervabg from "../../Assets/Image/impervabg.jpeg";

import Peris from "../../Assets/Logo/Perisaicard.png";
import Imperva from "../../Assets/Logo/imperva.png";
import Dell from "../../Assets/Logo/Dell.png";
import Giga from "../../Assets/Logo/Gigamon.png";
import Ibm from "../../Assets/Logo/Ibm.png";
import Hawlett from "../../Assets/Logo/Hewlett.png";
import H3c from "../../Assets/Logo/h3c.png";
import Hat from "../../Assets/Logo/Red Hat.png";
import Fortinet from "../../Assets/Logo/Fortinet.png";
import Nutanix from "../../Assets/Logo/Nutanix.png";
import Cyberpark from "../../Assets/Logo/Cyberpark.png";
import Synopsys from "../../Assets/Logo/Synopsis.png";
import Quantum from "../../Assets/Logo/Quantum.png";
import Netcraft from "../../Assets/Logo/Netcraft.png";
import Effecient from "../../Assets/Logo/Efficientip.png";
import Estim from "../../Assets/Logo/Estim.png";
import Odoo from "../../Assets/Logo/Odoo.png";
import Aruba from "../../Assets/Logo/Aruba.png";
import Zoom from "../../Assets/Logo/Zoom.png";
import Ets from "../../Assets/Logo/Ets.png";
import Paloalto from "../../Assets/Logo/Paloalto.png";
import Sumo from "../../Assets/Logo/Sumologic.png";
import Apc from "../../Assets/Logo/Apc.png";
import Thales from "../../Assets/Logo/Thales.png";
import Fores from "../../Assets/Logo/Forescout.png";
import Mine from "../../Assets/Logo/Itsmine.png";
import Tenalble from "../../Assets/Logo/Tenable.png";
import Hikv from "../../Assets/Logo/Hikvision.png";
import Prtg from "../../Assets/Logo/Prtg.png";
import Lenovo from "../../Assets/Logo/Lenovo.png";
import Huawei from "../../Assets/Logo/Huawei.png";
import Trend from "../../Assets/Logo/Trendm.png";
import Rans from "../../Assets/Logo/RansNet.png";
import Delinea from "../../Assets/Logo/Delinea.png";
import Ridge from "../../Assets/Logo/Ridge.png";
import Positive from "../../Assets/Logo/Positive.png";
import LKPP from "../../Assets/Logo/LKPP.png";
import LPSE from "../../Assets/Logo/LPSE.png";
import Catalogue from "../../Assets/Logo/Catalogue.png";

const COLORS = {
  navy: "#0B2745",
  navyLight: "#1C406D",
  blue: "#2392D0",
  softBlue: "#EAF6FC",
};

const partners = [
  { id: 1, name: "Peris.ai", image: Peris },
  { id: 2, name: "Imperva", image: Imperva },
  { id: 3, name: "Gigamon", image: Giga },
  { id: 4, name: "Dell", image: Dell },
  { id: 5, name: "H3C", image: H3c },
  { id: 6, name: "IBM", image: Ibm },
  { id: 7, name: "Red Hat", image: Hat },
  { id: 8, name: "Fortinet", image: Fortinet },
  { id: 9, name: "Nutanix", image: Nutanix },
  { id: 10, name: "Cyberpark", image: Cyberpark },
  { id: 11, name: "Synopsys", image: Synopsys },
  { id: 12, name: "Quantum", image: Quantum },
  { id: 13, name: "Netcraft", image: Netcraft },
  { id: 14, name: "EfficientIP", image: Effecient },
  { id: 15, name: "Estim", image: Estim },
  { id: 16, name: "Odoo", image: Odoo },
  { id: 17, name: "Aruba", image: Aruba },
  { id: 18, name: "Zoom", image: Zoom },
  { id: 19, name: "ETS", image: Ets },
  { id: 20, name: "Palo Alto", image: Paloalto },
  { id: 21, name: "Sumo Logic", image: Sumo },
  { id: 22, name: "APC", image: Apc },
  { id: 23, name: "Thales", image: Thales },
  { id: 24, name: "Forescout", image: Fores },
  { id: 25, name: "ItsMine", image: Mine },
  { id: 26, name: "Tenable", image: Tenalble },
  { id: 27, name: "Hikvision", image: Hikv },
  { id: 28, name: "PRTG", image: Prtg },
  { id: 29, name: "Lenovo", image: Lenovo },
  { id: 30, name: "Huawei", image: Huawei },
  { id: 31, name: "Trend Micro", image: Trend },
  { id: 32, name: "RansNet", image: Rans },
  { id: 33, name: "Delinea", image: Delinea },
  { id: 34, name: "Ridge", image: Ridge },
  { id: 35, name: "Positive Technologies", image: Positive },
  { id: 36, name: "Hewlett Packard Enterprise", image: Hawlett },
];

const services = [
  {
    id: 1,
    number: "01",
    title: "IT Consulting",
    description:
      "Strategic technology consulting to align infrastructure, security, and digital transformation with your business objectives.",
    image: Consultant,
  },
  {
    id: 2,
    number: "02",
    title: "Cyber Security",
    description:
      "End-to-end protection for applications, networks, data, identities, and critical enterprise environments.",
    image: SecurityCctv,
  },
  {
    id: 3,
    number: "03",
    title: "Managed Services & SOC",
    description:
      "Continuous monitoring, operational support, threat detection, and response delivered by experienced specialists.",
    image: ITManagement,
  },
  {
    id: 4,
    number: "04",
    title: "Hardware & IT Integration",
    description:
      "Integrated enterprise infrastructure covering servers, storage, networks, data centers, and supporting systems.",
    image: Hardware,
  },
];

const advantages = [
  {
    id: 1,
    icon: <MonitorMobbile color={COLORS.blue} variant="Bold" size={40} />,
    title: "Business-Driven Solutions",
    description:
      "Every solution is designed around business requirements, operational priorities, and measurable outcomes.",
  },
  {
    id: 2,
    icon: <People color={COLORS.blue} variant="Bold" size={40} />,
    title: "Certified Professionals",
    description:
      "Our experienced professionals combine technical expertise, industry knowledge, and responsive support.",
  },
  {
    id: 3,
    icon: <FolderOpen color={COLORS.blue} variant="Bold" size={40} />,
    title: "Strong Technology Ecosystem",
    description:
      "We collaborate with global technology principals to deliver scalable, reliable, and future-ready solutions.",
  },
];

const stats = [
  { value: "10+", label: "Years of Experience" },
  { value: "35+", label: "Technology Partners" },
  { value: "100+", label: "Projects Delivered" },
  { value: "24/7", label: "Technical Support" },
];

function ArrowIcon({ className = "h-5 w-5" }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M5 12h14M13 6l6 6-6 6"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function CheckIcon() {
  return (
    <span className="flex h-6 w-6 flex-none items-center justify-center rounded-full bg-[#EAF6FC] text-[#2392D0]">
      <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" aria-hidden="true">
        <path
          d="m7 12 3 3 7-7"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}

function SectionHeading({ eyebrow, title, description, align = "left", light = false }) {
  const alignment = align === "center" ? "mx-auto items-center text-center" : "items-start text-left";

  return (
    <div className={`flex max-w-3xl flex-col ${alignment}`}>
      <div
        className={`mb-4 inline-flex items-center gap-2 rounded-full px-4 py-2 text-xs font-bold uppercase tracking-widest ${
          light ? "bg-white/10 text-[#8CD5FA]" : "bg-[#EAF6FC] text-[#1C75A8]"
        }`}
      >
        <span className={`h-1.5 w-1.5 rounded-full ${light ? "bg-[#8CD5FA]" : "bg-[#2392D0]"}`} />
        {eyebrow}
      </div>
      <h2 className={`text-3xl font-bold leading-tight md:text-4xl lg:text-5xl ${light ? "text-white" : "text-[#0B2745]"}`}>
        {title}
      </h2>
      {description ? (
        <p className={`mt-5 text-base leading-8 md:text-lg ${light ? "text-slate-300" : "text-slate-600"}`}>
          {description}
        </p>
      ) : null}
    </div>
  );
}

export default function Home() {
  const navigate = useNavigate();
  const swiperRef = React.useRef(null);

  React.useEffect(() => {
    AOS.init({ duration: 800, once: true, offset: 80 });
  }, []);

  return (
    <main className="overflow-hidden bg-white text-slate-800">
      {/* HERO */}
      <section className="px-4 pt-4 sm:px-6 lg:px-8">
        <div
          className="relative min-h-[720px] overflow-hidden rounded-[28px] bg-[#0B2745] shadow-2xl lg:min-h-[760px]"
          style={{ backgroundImage: `url(${Bg})`, backgroundPosition: "center", backgroundSize: "cover" }}
        >
          <video
            className="absolute inset-0 h-full w-full object-cover"
            autoPlay
            loop
            muted
            playsInline
            aria-hidden="true"
          >
            <source src={BgVideo} type="video/mp4" />
          </video>

          <div className="absolute inset-0 bg-gradient-to-r from-[#061A2E]/95 via-[#0B2745]/85 to-[#0B2745]/35" />
          <div className="absolute -right-24 -top-24 h-96 w-96 rounded-full border border-white/10" />
          <div className="absolute -right-8 top-12 h-72 w-72 rounded-full border border-white/10" />

          <div className="relative z-10 mx-auto flex min-h-[720px] max-w-7xl items-center px-6 py-24 sm:px-10 lg:min-h-[760px] lg:px-16">
            <div className="grid w-full items-center gap-14 lg:grid-cols-[1.25fr_0.75fr]">
              <div data-aos="fade-up">
                <div className="mb-7 inline-flex items-center gap-3 rounded-full border border-white/15 bg-white/10 px-4 py-2 text-xs font-semibold uppercase tracking-[0.18em] text-[#A8DFFF] backdrop-blur-md">
                  <span className="relative flex h-2 w-2">
                    <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#58C4F7] opacity-75" />
                    <span className="relative inline-flex h-2 w-2 rounded-full bg-[#58C4F7]" />
                  </span>
                  Enterprise IT & Cyber Security Partner
                </div>

                <h1 className="max-w-4xl text-4xl font-bold leading-[1.08] text-white sm:text-5xl lg:text-6xl xl:text-7xl">
                  Engineering a Secure,
                  <span className="block bg-gradient-to-r from-[#8CD5FA] to-white bg-clip-text text-transparent">
                    Connected Tomorrow.
                  </span>
                </h1>

                <p className="mt-7 max-w-2xl text-base leading-8 text-slate-200 sm:text-lg lg:text-xl">
                  We provide integrated technology solutions that strengthen infrastructure, protect critical data,
                  and accelerate digital transformation for modern organizations.
                </p>

                <div className="mt-10 flex flex-col gap-4 sm:flex-row">
                  <button
                    type="button"
                    onClick={() => navigate("/services")}
                    className="group inline-flex items-center justify-center gap-3 rounded-full bg-[#2392D0] px-7 py-4 text-sm font-bold text-white shadow-lg shadow-[#2392D0]/25 transition duration-300 hover:-translate-y-1 hover:bg-[#1C7FB6]"
                  >
                    Explore Our Solutions
                    <ArrowIcon className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1" />
                  </button>
                  <button
                    type="button"
                    onClick={() => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" })}
                    className="inline-flex items-center justify-center rounded-full border border-white/30 bg-white/5 px-7 py-4 text-sm font-bold text-white backdrop-blur-md transition duration-300 hover:-translate-y-1 hover:bg-white hover:text-[#0B2745]"
                  >
                    Talk to Our Team
                  </button>
                </div>

                <div className="mt-12 flex flex-wrap items-center gap-5 border-t border-white/15 pt-7">
                  <span className="text-xs font-semibold uppercase tracking-widest text-slate-400">Registered on</span>
                  <div className="flex items-center gap-5 rounded-2xl bg-white px-5 py-3 shadow-lg">
                    <img className="h-7 w-auto object-contain" src={LPSE} alt="LPSE" />
                    <img className="h-7 w-auto object-contain" src={LKPP} alt="LKPP" />
                    <img className="h-7 w-auto object-contain" src={Catalogue} alt="E-Catalogue" />
                  </div>
                </div>
              </div>

              <div className="relative hidden lg:block" data-aos="fade-left" data-aos-delay="150">
                <div className="relative mx-auto flex aspect-square max-w-[430px] items-center justify-center rounded-full border border-white/15 bg-white/5 p-12 backdrop-blur-sm">
                  <div className="absolute inset-8 rounded-full border border-dashed border-[#58C4F7]/30" />
                  <div className="absolute inset-16 rounded-full bg-[#2392D0]/10 blur-2xl" />
                  <img className="relative z-10 w-full drop-shadow-2xl" src={Logo} alt="Viktorindo Teknologi Prima" />
                  <div className="absolute -bottom-5 -left-8 rounded-2xl border border-white/15 bg-[#0B2745]/80 px-5 py-4 text-white shadow-xl backdrop-blur-lg">
                    <p className="text-xs uppercase tracking-widest text-[#8CD5FA]">Technology Focus</p>
                    <p className="mt-1 font-semibold">Secure. Reliable. Scalable.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* STATS */}
      <section className="relative z-20 mx-auto -mt-8 max-w-6xl px-6">
        <div className="grid overflow-hidden rounded-3xl border border-slate-100 bg-white shadow-xl sm:grid-cols-2 lg:grid-cols-4">
          {stats.map((item, index) => (
            <div
              key={item.label}
              className={`px-7 py-7 text-center ${index !== stats.length - 1 ? "lg:border-r lg:border-slate-100" : ""}`}
            >
              <p className="text-3xl font-bold text-[#1C406D] md:text-4xl">{item.value}</p>
              <p className="mt-2 text-sm font-medium text-slate-500">{item.label}</p>
            </div>
          ))}
        </div>
      </section>

      {/* SERVICES */}
      <section className="mx-auto max-w-7xl px-6 py-24 lg:px-8 lg:py-32">
        <div className="flex flex-col justify-between gap-8 lg:flex-row lg:items-end">
          <SectionHeading
            eyebrow="What We Do"
            title="Integrated Technology Solutions for Enterprise Growth"
            description="From strategic planning to implementation and managed operations, we help organizations build resilient and future-ready technology environments."
          />
          <Link
            to="/services"
            className="group inline-flex w-fit items-center gap-3 text-sm font-bold text-[#1C406D] transition hover:text-[#2392D0]"
          >
            View all services
            <span className="flex h-10 w-10 items-center justify-center rounded-full border border-slate-200 transition group-hover:border-[#2392D0] group-hover:bg-[#2392D0] group-hover:text-white">
              <ArrowIcon className="h-4 w-4" />
            </span>
          </Link>
        </div>

        <div className="mt-14 grid gap-6 md:grid-cols-2">
          {services.map((service, index) => (
            <article
              key={service.id}
              className="group relative min-h-[390px] overflow-hidden rounded-[28px] bg-[#0B2745] shadow-lg"
              data-aos="fade-up"
              data-aos-delay={index * 80}
            >
              <img
                src={service.image}
                alt={service.title}
                className="absolute inset-0 h-full w-full object-cover transition duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#061A2E] via-[#0B2745]/75 to-[#0B2745]/10" />
              <div className="relative flex min-h-[390px] flex-col justify-between p-7 sm:p-9">
                <div className="flex items-start justify-between">
                  <span className="text-sm font-bold tracking-widest text-[#8CD5FA]">{service.number}</span>
                  <span className="flex h-11 w-11 items-center justify-center rounded-full border border-white/20 bg-white/10 text-white backdrop-blur transition duration-300 group-hover:bg-[#2392D0]">
                    <ArrowIcon className="h-5 w-5 -rotate-45 transition duration-300 group-hover:rotate-0" />
                  </span>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-white sm:text-3xl">{service.title}</h3>
                  <p className="mt-4 max-w-xl leading-7 text-slate-300">{service.description}</p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>

      {/* FEATURED TECHNOLOGY */}
      <section className="bg-[#F5F9FC] py-24 lg:py-32">
        <div className="mx-auto grid max-w-7xl items-center gap-14 px-6 lg:grid-cols-2 lg:px-8">
          <div className="relative" data-aos="fade-right">
            <div className="absolute -left-6 -top-6 h-32 w-32 rounded-full bg-[#2392D0]/10 blur-2xl" />
            <div className="relative overflow-hidden rounded-[32px] bg-[#1C406D] p-3 shadow-2xl">
              <div
                className="relative min-h-[520px] overflow-hidden rounded-[24px] bg-cover bg-center"
                style={{ backgroundImage: `url(${Impervabg})` }}
              >
                <div className="absolute inset-0 bg-gradient-to-br from-white/95 via-white/80 to-[#BFE8FA]/75" />
                <div className="relative flex min-h-[520px] flex-col items-center justify-center p-10">
                  <div className="absolute left-7 top-7 rounded-full bg-[#0B2745] px-4 py-2 text-xs font-bold uppercase tracking-widest text-white">
                    Featured Technology
                  </div>
                  <img src={Imperva} alt="Imperva" className="w-full max-w-sm object-contain" />
                  <div className="absolute bottom-7 left-7 right-7 grid grid-cols-2 gap-3">
                    <div className="rounded-2xl bg-white/80 p-4 backdrop-blur">
                      <p className="text-xs font-bold uppercase tracking-widest text-slate-400">Focus</p>
                      <p className="mt-1 font-bold text-[#1C406D]">Data Security</p>
                    </div>
                    <div className="rounded-2xl bg-white/80 p-4 backdrop-blur">
                      <p className="text-xs font-bold uppercase tracking-widest text-slate-400">Protection</p>
                      <p className="mt-1 font-bold text-[#1C406D]">Enterprise Grade</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div data-aos="fade-left">
            <SectionHeading
              eyebrow="Technology Spotlight"
              title="Protect Critical Data with Imperva Database Security"
              description="A comprehensive data security platform designed to protect sensitive enterprise information from internal and external threats while supporting regulatory compliance."
            />

            <div className="mt-8 space-y-4">
              {[
                "Discover and classify sensitive data across enterprise environments.",
                "Monitor database activity and detect suspicious behavior in real time.",
                "Strengthen compliance readiness for GDPR, HIPAA, PCI DSS, and other standards.",
              ].map((item) => (
                <div key={item} className="flex items-start gap-4">
                  <CheckIcon />
                  <p className="leading-7 text-slate-600">{item}</p>
                </div>
              ))}
            </div>

            <a
              href="https://www.imperva.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="group mt-10 inline-flex items-center gap-3 rounded-full bg-[#1C406D] px-7 py-4 text-sm font-bold text-white transition duration-300 hover:-translate-y-1 hover:bg-[#2392D0]"
            >
              Learn More About Imperva
              <ArrowIcon className="h-5 w-5 transition-transform group-hover:translate-x-1" />
            </a>
          </div>
        </div>
      </section>

      {/* PARTNERS */}
      <section className="relative overflow-hidden bg-[#0B2745] py-24 lg:py-32">
        <div className="absolute -left-40 top-20 h-96 w-96 rounded-full bg-[#2392D0]/10 blur-3xl" />
        <div className="absolute -right-40 bottom-0 h-96 w-96 rounded-full bg-white/5 blur-3xl" />

        <div className="relative mx-auto max-w-7xl px-6 lg:px-8">
          <div className="flex flex-col justify-between gap-8 lg:flex-row lg:items-end">
            <SectionHeading
              eyebrow="Technology Ecosystem"
              title="Powered by World-Class Technology Partners"
              description="Our partner ecosystem enables us to design integrated, scalable, and trusted solutions across cybersecurity, infrastructure, cloud, networking, and enterprise applications."
              light
            />

            <div className="flex gap-3">
              <button
                type="button"
                aria-label="Previous partner"
                onClick={() => swiperRef.current?.slidePrev()}
                className="flex h-12 w-12 items-center justify-center rounded-full border border-white/20 text-white transition hover:bg-white hover:text-[#0B2745]"
              >
                <ArrowIcon className="h-5 w-5 rotate-180" />
              </button>
              <button
                type="button"
                aria-label="Next partner"
                onClick={() => swiperRef.current?.slideNext()}
                className="flex h-12 w-12 items-center justify-center rounded-full border border-white/20 text-white transition hover:bg-white hover:text-[#0B2745]"
              >
                <ArrowIcon className="h-5 w-5" />
              </button>
            </div>
          </div>

          <Swiper
            className="mt-14 w-full"
            onSwiper={(swiper) => {
              swiperRef.current = swiper;
            }}
            spaceBetween={18}
            breakpoints={{
              320: { slidesPerView: 1.35 },
              480: { slidesPerView: 2 },
              768: { slidesPerView: 3 },
              1024: { slidesPerView: 4 },
              1280: { slidesPerView: 5 },
            }}
          >
            {partners.map((partner) => (
              <SwiperSlide key={partner.id} className="h-auto">
                <div className="flex h-36 items-center justify-center rounded-2xl border border-white/10 bg-white p-7 shadow-lg transition duration-300 hover:-translate-y-1">
                  <img
                    src={partner.image}
                    alt={partner.name}
                    className="max-h-20 w-full object-contain"
                    loading="lazy"
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </section>

      {/* ABOUT */}
      <section className="mx-auto grid max-w-7xl items-center gap-14 px-6 py-24 lg:grid-cols-2 lg:px-8 lg:py-32">
        <div data-aos="fade-right">
          <SectionHeading
            eyebrow="About Viktorindo"
            title="Your Trusted Partner for Digital Transformation"
            description="PT Viktorindo Teknologi Prima is an experienced IT solutions company delivering consulting, enterprise architecture, implementation, integration, and managed services."
          />

          <p className="mt-6 leading-8 text-slate-600">
            Supported by competent professionals and partnerships with global technology principals, we help clients
            modernize business processes, improve operational resilience, and protect critical digital assets.
          </p>

          <div className="mt-8 grid gap-4 sm:grid-cols-2">
            {["Enterprise Architecture", "Infrastructure Modernization", "Cyber Security", "Managed Operations"].map(
              (item) => (
                <div key={item} className="flex items-center gap-3 rounded-2xl border border-slate-200 bg-white p-4">
                  <CheckIcon />
                  <span className="text-sm font-bold text-[#1C406D]">{item}</span>
                </div>
              )
            )}
          </div>

          <Link
            to="/about"
            className="group mt-9 inline-flex items-center gap-3 text-sm font-bold text-[#1C406D] transition hover:text-[#2392D0]"
          >
            Discover Our Company
            <ArrowIcon className="h-5 w-5 transition-transform group-hover:translate-x-1" />
          </Link>
        </div>

        <div className="relative" data-aos="fade-left">
          <div className="absolute -right-6 -top-6 h-40 w-40 rounded-full bg-[#2392D0]/10 blur-2xl" />
          <div
            className="relative min-h-[560px] overflow-hidden rounded-[32px] bg-cover bg-center shadow-2xl"
            style={{ backgroundImage: `url(${Code})` }}
          >
            <div className="absolute inset-0 bg-gradient-to-t from-[#061A2E] via-[#0B2745]/45 to-transparent" />
            <div className="relative flex min-h-[560px] flex-col justify-between p-8 sm:p-10">
              <div className="flex justify-end">
                <div className="rounded-2xl border border-white/20 bg-white/10 px-5 py-4 text-right text-white backdrop-blur-lg">
                  <p className="text-xs uppercase tracking-widest text-[#A8DFFF]">Our Commitment</p>
                  <p className="mt-1 font-bold">Delivering Excellence</p>
                </div>
              </div>
              <div>
                <img className="mb-8 w-64" src={Logo} alt="Viktorindo Teknologi Prima" />
                <p className="max-w-md text-lg font-medium leading-8 text-white">
                  Building secure and reliable technology foundations for organizations across Indonesia.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ADVANTAGES */}
      <section className="bg-[#F5F9FC] py-24 lg:py-32">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <SectionHeading
            eyebrow="Why Choose Us"
            title="Expertise That Creates Lasting Business Value"
            description="We combine technical capability, strong partnerships, and a practical delivery approach to help clients achieve sustainable results."
            align="center"
          />

          <div className="mt-14 grid gap-6 md:grid-cols-3">
            {advantages.map((item, index) => (
              <article
                key={item.id}
                className="group rounded-[28px] border border-slate-200 bg-white p-8 shadow-sm transition duration-300 hover:-translate-y-2 hover:border-[#B9E1F5] hover:shadow-xl"
                data-aos="fade-up"
                data-aos-delay={index * 100}
              >
                <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-[#EAF6FC] transition duration-300 group-hover:bg-[#0B2745]">
                  {item.icon}
                </div>
                <h3 className="mt-7 text-xl font-bold text-[#0B2745]">{item.title}</h3>
                <p className="mt-4 leading-7 text-slate-600">{item.description}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="px-4 py-24 sm:px-6 lg:px-8">
        <div
          className="relative mx-auto max-w-7xl overflow-hidden rounded-[32px] bg-[#0B2745] bg-cover bg-center px-6 py-16 shadow-2xl sm:px-10 lg:px-16 lg:py-20"
          style={{ backgroundImage: `url(${Building})` }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-[#061A2E]/95 via-[#0B2745]/90 to-[#1C406D]/75" />
          <div className="relative flex flex-col justify-between gap-10 lg:flex-row lg:items-center">
            <div className="max-w-3xl">
              <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#8CD5FA]">Start Your IT Transformation</p>
              <h2 className="mt-4 text-3xl font-bold leading-tight text-white sm:text-4xl lg:text-5xl">
                Let’s Build a More Secure and Resilient Digital Future.
              </h2>
              <p className="mt-5 max-w-2xl leading-8 text-slate-300">
                Discuss your technology challenges with our team and discover the right solution for your organization.
              </p>
            </div>
            <button
              type="button"
              onClick={() => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" })}
              className="group inline-flex flex-none items-center justify-center gap-3 rounded-full bg-white px-7 py-4 text-sm font-bold text-[#0B2745] transition duration-300 hover:-translate-y-1 hover:bg-[#2392D0] hover:text-white"
            >
              Contact Our Team
              <ArrowIcon className="h-5 w-5 transition-transform group-hover:translate-x-1" />
            </button>
          </div>
        </div>
      </section>

      {/* CONTACT */}
      <section id="contact" className="bg-[#071C31] py-24 lg:py-32">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="grid gap-12 lg:grid-cols-[0.9fr_1.1fr]">
            <div>
              <SectionHeading
                eyebrow="Contact Us"
                title="Ready to Discuss Your Technology Needs?"
                description="Connect with our team for consultation, solution planning, project requirements, or technical support."
                light
              />

              <div className="mt-10 space-y-5">
                <div className="rounded-2xl border border-white/10 bg-white/5 p-5">
                  <p className="text-xs font-bold uppercase tracking-widest text-[#8CD5FA]">Office Address</p>
                  <p className="mt-2 leading-7 text-slate-300">
                    Grand Orchard Square Blok D No 10, Summarecon Kelapa Gading, Jl. Terusan Kelapa Hybrida, Sukapura, Cilincing, Jakarta Utara, 14140
                  </p>
                </div>
                <div className="grid gap-5 sm:grid-cols-2">
                  <a
                    href="mailto:support@viktorindo.co.id"
                    className="rounded-2xl border border-white/10 bg-white/5 p-5 transition hover:bg-white/10"
                  >
                    <p className="text-xs font-bold uppercase tracking-widest text-[#8CD5FA]">Email</p>
                    <p className="mt-2 text-sm font-semibold text-white">support@viktorindo.co.id</p>
                  </a>
                  <a
                    href="tel:+6282122512660"
                    className="rounded-2xl border border-white/10 bg-white/5 p-5 transition hover:bg-white/10"
                  >
                    <p className="text-xs font-bold uppercase tracking-widest text-[#8CD5FA]">Phone</p>
                    <p className="mt-2 text-sm font-semibold text-white">(+62) 821-2251-2660</p>
                  </a>
                </div>
              </div>
            </div>

            <div className="overflow-hidden rounded-[28px] border border-white/10 bg-white shadow-2xl">
              <div className="grid md:grid-cols-2">
                <div className="relative min-h-[320px] md:min-h-full">
                  <iframe
                    title="Viktorindo Teknologi Prima location"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3966.8672938864183!2d106.91603687509482!3d-6.148519193838531!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e698b9218a79b67%3A0xf398bbaac4b857c2!2sVIKTORINDO%20TEKNOLOGI%20PRIMA!5e0!3m2!1sid!2sid!4v1701922294772!5m2!1sid!2sid"
                    className="absolute inset-0 h-full w-full border-0"
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  />
                </div>
                <ContactForm />
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

function ContactForm() {
  const formRef = React.useRef(null);
  const [formData, setFormData] = React.useState({
    user_name: "",
    user_email: "",
    message: "",
  });
  const [status, setStatus] = React.useState("idle");
  const [feedback, setFeedback] = React.useState("");

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((previous) => ({ ...previous, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!formData.user_name.trim() || !formData.user_email.trim() || !formData.message.trim()) {
      setStatus("error");
      setFeedback("Please complete all required fields.");
      return;
    }

    try {
      setStatus("loading");
      setFeedback("");

      await emailjs.sendForm(
        process.env.REACT_APP_EMAIL_KEY,
        process.env.REACT_APP_TEMPLATE_KEY,
        formRef.current,
        process.env.REACT_APP_PUBLIC_KEY
      );

      setFormData({ user_name: "", user_email: "", message: "" });
      setStatus("success");
      setFeedback("Thank you. Your message has been sent successfully.");
    } catch (error) {
      console.error("EmailJS error:", error);
      setStatus("error");
      setFeedback("Your message could not be sent. Please try again or contact us by email.");
    }
  };

  return (
    <form ref={formRef} onSubmit={handleSubmit} className="p-7 sm:p-9">
      <p className="text-xs font-bold uppercase tracking-widest text-[#2392D0]">Send a Message</p>
      <h3 className="mt-3 text-2xl font-bold text-[#0B2745]">How can we help?</h3>
      <p className="mt-3 text-sm leading-6 text-slate-500">
        Tell us about your requirements and our team will get in touch with you.
      </p>

      <div className="mt-7 space-y-5">
        <div>
          <label htmlFor="name" className="mb-2 block text-sm font-semibold text-slate-700">
            Full Name
          </label>
          <input
            id="name"
            name="user_name"
            type="text"
            value={formData.user_name}
            onChange={handleChange}
            placeholder="Enter your name"
            className="w-full rounded-xl border border-slate-200 bg-slate-50 px-4 py-3.5 text-sm text-slate-900 outline-none transition placeholder:text-slate-400 focus:border-[#2392D0] focus:bg-white focus:ring-4 focus:ring-[#2392D0]/10"
          />
        </div>

        <div>
          <label htmlFor="email" className="mb-2 block text-sm font-semibold text-slate-700">
            Email Address
          </label>
          <input
            id="email"
            name="user_email"
            type="email"
            value={formData.user_email}
            onChange={handleChange}
            placeholder="name@company.com"
            className="w-full rounded-xl border border-slate-200 bg-slate-50 px-4 py-3.5 text-sm text-slate-900 outline-none transition placeholder:text-slate-400 focus:border-[#2392D0] focus:bg-white focus:ring-4 focus:ring-[#2392D0]/10"
          />
        </div>

        <div>
          <label htmlFor="message" className="mb-2 block text-sm font-semibold text-slate-700">
            Message
          </label>
          <textarea
            id="message"
            name="message"
            rows={5}
            value={formData.message}
            onChange={handleChange}
            placeholder="Describe your technology requirements..."
            className="w-full resize-none rounded-xl border border-slate-200 bg-slate-50 px-4 py-3.5 text-sm text-slate-900 outline-none transition placeholder:text-slate-400 focus:border-[#2392D0] focus:bg-white focus:ring-4 focus:ring-[#2392D0]/10"
          />
        </div>
      </div>

      {feedback ? (
        <p className={`mt-4 text-sm ${status === "success" ? "text-emerald-600" : "text-red-600"}`}>{feedback}</p>
      ) : null}

      <button
        type="submit"
        disabled={status === "loading"}
        className="group mt-6 inline-flex w-full items-center justify-center gap-3 rounded-xl bg-[#1C406D] px-6 py-4 text-sm font-bold text-white transition duration-300 hover:bg-[#2392D0] disabled:cursor-not-allowed disabled:opacity-60"
      >
        {status === "loading" ? "Sending Message..." : "Send Message"}
        {status !== "loading" ? <ArrowIcon className="h-5 w-5 transition-transform group-hover:translate-x-1" /> : null}
      </button>
    </form>
  );
}